import { Scene } from '../Scene';
import { SceneManifest } from '../SceneManifest';
import { NavigationSystem, TiledNavMeshStreamer, TiledVolumeGrid } from '../../navigation-mesh';
import { TileParseWorkerClient } from '../../workers/TileParseWorkerClient';

export async function loadNavigationMesh(
  scene: Scene,
  manifest: SceneManifest,
  spawnX: number = 0,
  spawnZ: number = 0,
  workerClient?: TileParseWorkerClient,
): Promise<void> {
  if (!manifest.navigationMesh) return;

  const navRef = manifest.navigationMesh;
  const resourceLoader = scene.ctx.resourceLoader;

  scene.navigation = new NavigationSystem(
    scene.boundingBox,
    navRef.settings.voxelSize,
    navRef.settings.maxNeighbourStepHeight,
  );

  const streamer = new TiledNavMeshStreamer(navRef, scene.navigation, resourceLoader, undefined, workerClient);
  streamer.startInitialTiles(spawnX, spawnZ);

  // Volgrid streamer shares the navmesh streamer's archive cache so each `.tile`
  // is fetched + parsed exactly once even though both consume different slices.
  const tiledGrid = new TiledVolumeGrid(
    navRef.tilesX,
    navRef.tilesZ,
    navRef.tileWorldSize,
    navRef.worldMinX,
    navRef.worldMinZ,
    navRef.settings.voxelSize,
    (tx, tz) => streamer.hasVolgrid(tx, tz),
    streamer.getArchiveCache(),
    workerClient,
  );

  await tiledGrid.loadInitialTiles(spawnX, spawnZ);

  scene.volumeGrid = tiledGrid;
  scene.navMeshStreamer = streamer;
}
